// extracted by mini-css-extract-plugin
export default {"cards":"cards___mVfPV","flat_images":"flat_images___kX3hC"};